import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {SiteFiltersType} from "../../types/site-filters.type";
import {ViewFilterSettingsService} from "../../services/view-filter-settings.service";
import {FulfillmentSubTypeType} from "../../../fulfillment/types/fulfillment-sub-type.type";
import {CommonsService} from "../../services/commons-service.service";

export class BringozFiltersDropdownComponent implements IController {

  includeFilters: SiteFiltersType[];
  optionIdsMap: any;
  excludeIdsMap: any;
  filters: any;
  selectedQuickFilterId?: string;
  pageName?: string;
  queryMap: {};
  hideDisplay?: boolean;
  hideText?: boolean;
  isDisabled?: boolean;
  disabledText?: string;
  eventNamePrefix?: string;
  skipContext?: boolean;
  onChange: Function;

  public hasActiveFilters = false;

  private subFiltersTypes: SiteFiltersType[];
  private fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;
  private lastFiltersCopy: any;

  /* @ngInject */
  constructor(private $mdPanel, private $q, private $log: ILogService, private viewFilterSettingsService: ViewFilterSettingsService, private commonsService: CommonsService) {
    this.subFiltersTypes = [
      SiteFiltersType.noArea,
      SiteFiltersType.serviceAreaPickup,
      SiteFiltersType.serviceAreaDropoff,
      SiteFiltersType.serviceAreasServiceTypes,
      SiteFiltersType.noPickUpArea,
      SiteFiltersType.noDropOffArea,
      SiteFiltersType.groups
    ];
  }

  $onInit() {
    this.lastFiltersCopy = angular.copy(this.filters);
    this.updateHasActiveFilters();
  }

  $onChanges(changes) {
    if (changes.filters) {
      this.lastFiltersCopy = angular.copy(this.filters);
    }
    this.updateHasActiveFilters();
  }

  $doCheck() {
    if (!angular.equals(this.filters, this.lastFiltersCopy)) {
      this.lastFiltersCopy = angular.copy(this.filters);
      this.updateHasActiveFilters();
    }
  }

  updateHasActiveFilters() {
    this.hasActiveFilters = this.hasFilters();
  }

  openDropdown($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.currentTarget || $event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.ALIGN_START,
        this.$mdPanel.yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-filters-dropdown-panel ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'include-filters="ctrl.includeFilters" ' +
        'filters="ctrl.filters" ' +
        'selected-quick-filter-id="ctrl.selectedQuickFilterId" ' +
        'page-name="ctrl.pageName" ' +
        'query-map="ctrl.queryMap" ' +
        'exclude-ids-map="ctrl.excludeIdsMap" ' +
        'option-ids-map="ctrl.optionIdsMap" ' +
        'event-name-prefix="ctrl.eventNamePrefix" ' +
        'on-submit="ctrl.onSubmit(filters, selectedQuickFilter)" ' +
        'on-cancel="ctrl.onCancel()">' +
        '</bringoz-filters-dropdown-panel>',
      locals: {
        includeFilters: this.includeFilters,
        filters: angular.copy(this.filters),
        selectedQuickFilterId: this.selectedQuickFilterId,
        pageName: this.pageName,
        queryMap: this.queryMap,
        excludeIdsMap: this.excludeIdsMap,
        optionIdsMap: this.optionIdsMap,
        eventNamePrefix: this.eventNamePrefix,
        parentCtrl: this
      },
      controller: [
        'mdPanelRef', 'includeFilters', 'filters', 'selectedQuickFilterId', 'pageName', 'queryMap', 'excludeIdsMap', 'optionIdsMap', 'parentCtrl',
        function (mdPanelRef, includeFilters, filters, selectedQuickFilterId, pageName, queryMap, excludeIdsMap, optionIdsMap, parentCtrl) {
          this.mdPanelRef = mdPanelRef;
          this.includeFilters = includeFilters;
          this.filters = filters;
          this.selectedQuickFilterId = selectedQuickFilterId;
          this.pageName = pageName;
          this.queryMap = queryMap;
          this.excludeIdsMap = excludeIdsMap;
          this.optionIdsMap = optionIdsMap;

          this.onSubmit = (updatedFilters, selectedQuickFilter) => {
            parentCtrl._setContextIds(updatedFilters);
            parentCtrl.onChange({filters: updatedFilters, selectedQuickFilter: selectedQuickFilter});
            mdPanelRef.destroy();
          };

          this.onCancel = () => {
            mdPanelRef.destroy();
          };
        }
      ],
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: false,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        if (reason === 'clickOutsideToClose' || reason === 'escapeToClose') {
          panel.destroy();
        }
      }
    };

    this.$mdPanel.open(config);
  }

  hasFilters() {
    if (!this.includeFilters || !this.filters) {
      return false;
    }
    return !!this.includeFilters.find((f) => {
      if (this.subFiltersTypes.includes(f)) {
        return false;
      }
      return _.isArray(this.filters[f]) ? !!this.filters[f]?.length : !_.isUndefined(this.filters[f]);
    });
  }

  onResetFilter(filterName) {
    this.commonsService.resetFilterField(this.filters, filterName, this.excludeIdsMap);
    this._setContextIds(this.filters);
    this.onChange({filters: this.filters});
  }

  _setContextIds(filters) {
    if (this.skipContext) {
      return;
    }
    this.viewFilterSettingsService.setServiceAreaIds(filters?.serviceAreaIds || []);
    this.viewFilterSettingsService.setBranchIds(filters?.branchIds || []);
    this.viewFilterSettingsService.setAccountIds(filters?.accountIds || []);
    this.viewFilterSettingsService.setBillingAccountIds(filters?.billingAccountIds || []);
    this.viewFilterSettingsService.setBillingOrderStatus(filters?.billingOrderStatus || undefined);
    this.viewFilterSettingsService.setTags(filters?.tags || []);
    this.viewFilterSettingsService.setPackagesIds(filters?.packagesIds || []);
    this.viewFilterSettingsService.setBillingOrderInvoiceStatuses(filters?.billingOrderInvoiceStatuses || []);
    this.viewFilterSettingsService.setIsConsolidated(typeof filters?.isConsolidated === "boolean" ? filters?.isConsolidated : undefined);
    this.viewFilterSettingsService.setHasPrice(typeof filters?.hasPrice === "boolean" ? filters?.hasPrice : undefined);
    this.viewFilterSettingsService.setDateRangeTemplateType(filters.dateRangeTemplateType || undefined);
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozFiltersDropdown', {
    bindings: {
      includeFilters: '<',
      excludeIdsMap: '<',
      optionIdsMap: '<',
      filters: '<',
      selectedQuickFilterId: '<?',
      pageName: '<?',
      queryMap: '<?',
      hideDisplay: '<?',
      hideText: '<?',
      isDisabled: '<?',
      disabledText: '@?',
      eventNamePrefix: '@?',
      skipContext: '<?',
      onChange: '&'
    },
    template: require('./bringoz-filters-dropdown.html').default,
    controller: BringozFiltersDropdownComponent
  });
